import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "gatsby-plugin-theme-ui"
    }}>{`gatsby-plugin-theme-ui`}</h1>
    <p>{`Gatsby plugin for adding Theme UI context`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i theme-ui gatsby-plugin-theme-ui
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: ['gatsby-plugin-theme-ui'],
}
`}</code></pre>
    <p>{`In addition to providing context, this plugin will also
prevent a flash of unstyled colors when using color modes.`}</p>
    <h2 {...{
      "id": "customizing-the-theme"
    }}>{`Customizing the theme`}</h2>
    <p>{`To customize the theme used in your Gatsby site,
shadow the `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/index.js`}</inlineCode>{` module.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/index.js
export default {
  colors: {
    text: '#111',
    background: '#fff',
  },
}
`}</code></pre>
    <h2 {...{
      "id": "extending-a-theme"
    }}>{`Extending a theme`}</h2>
    <p>{`To extend a Gatsby theme that uses Theme UI, import the base theme and export a new theme object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/index.js
import baseTheme from 'gatsby-theme-blog/src/gatsby-plugin-theme-ui'

export default {
  ...baseTheme,
  colors: {
    ...baseTheme.colors,
    text: '#111',
    background: '#fff',
  },
}
`}</code></pre>
    <p>{`You can also import and use presets from `}<a parentName="p" {...{
        "href": "https://theme-ui.com/presets"
      }}>{`@theme-ui/presets`}</a>{` to use as a starting point.`}</p>
    <h2 {...{
      "id": "color-modes"
    }}>{`Color Modes`}</h2>
    <p>{`To enable support for multiple color modes, add a nested `}<inlineCode parentName="p">{`modes`}</inlineCode>{` object to `}<inlineCode parentName="p">{`theme.colors`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/index.js
export default {
  colors: {
    text: '#000',
    background: '#fff',
    modes: {
      dark: {
        text: '#fff',
        background: '#000',
      },
    },
  },
}
`}</code></pre>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <p>{`Custom MDX components that will receive styles from the theme can be included by adding a `}<inlineCode parentName="p">{`src/gatsby-plugin-theme-ui/components.js`}</inlineCode>{` module.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/gatsby-plugin-theme-ui/components.js
export default {
  h1: props => (
    <h1 {...props}>
      <a href={\`#\${props.id}\`}>{props.children}</a>
    </h1>
  ),
}
`}</code></pre>
    <p>{`MIT License`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      